import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Modal } from '../../../components/modal/index';

export type GrantAccessProps = {
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: () => void;
};

const GrantAccessModal: FC<GrantAccessProps> = ({ isOpen, onDismiss, onSuccess }) => (
  <Modal
    description={<AppFormattedMessage id="ARE_YOU_SURE_YOU_WANT_GRANT_ACCESS" />}
    dismissButtonContent={<AppFormattedMessage id="NO" />}
    isOpen={isOpen}
    onDismiss={onDismiss}
    onSuccess={onSuccess}
    successButtonClassName="bg-brand-700"
    successButtonContent={<AppFormattedMessage id="YES_GRANT" />}
    title={<AppFormattedMessage id="GRANT_ACCESS" />}
  />
);

export default GrantAccessModal;
